const nav = document.getElementById('navigation');

if (nav) {
	const mainItems = Array.from(
		nav.querySelectorAll('.main-nav > ul > li > :where(a, button)'),
	);

	let lastX = 0;
	let lastY = 0;
	let isHorizontalMovement = false;
	let timeout;
	let activeItem;

	nav.addEventListener('mousemove', function (event) {
		const deltaX = Math.abs(event.clientX - lastX);
		const deltaY = Math.abs(event.clientY - lastY);

		// Berechnen des Winkels in Radiant
		const angleRad = Math.atan2(deltaY, deltaX);

		// Umwandeln des Winkels in Grad
		const angleDeg = angleRad * (180 / Math.PI);

		isHorizontalMovement = angleDeg < 20;

		lastX = event.clientX;
		lastY = event.clientY;
	});

	const activate = item => {
		mainItems.forEach(i => i.closest('li')?.removeAttribute('data-active'));
		nav.querySelector(`img[data-active]`)?.removeAttribute('data-active');
		item.closest('li')?.setAttribute('data-active', '');
		nav
			.querySelector(`img[data-item='${item.dataset.item}']`)
			?.setAttribute('data-active', '');
		activeItem = item;
	};

	const deactivate = item => {
		nav
			.querySelector(`img[data-item='${item.dataset.item}']`)
			?.removeAttribute('data-active');
		item.closest('li')?.removeAttribute('data-active');
		activeItem = null;
	};

	mainItems.forEach(item => {
		item.addEventListener('mouseenter', () => {
			clearTimeout(timeout);

			if (isHorizontalMovement) {
				activate(item);
			} else {
				timeout = setTimeout(() => {
					activate(item);
				}, 200);
			}
		});

		item.closest('li')?.addEventListener('mouseleave', () => {
			clearTimeout(timeout);

			timeout = setTimeout(() => {
				if (activeItem === item) {
					deactivate(item);
				}
			}, 1000);
		});

		item.addEventListener('focus', () => {
			activate(item);
		});
	});
}
